import React from "react";
import { Link } from "react-router-dom";

const AboutArea = () => {
  return (
    <section className="about-area">
      <div className="container custom-container">
        <div className="about-inner">
          <div className="row align-items-center justify-content-center">
            <div className="col-46 order-0 order-lg-2">
              <div className="about-img text-end">
                <img alt="about-area"  src="/img/my-img/banner.png"  />
              </div>
            </div>
            <div className="col-54">
              <div className="about-content">
                <div className="section-title mb-25">
                  <h3 className="sub-title">About Company</h3>
                  <h2 className="title">
                  The Digital Creative  Graphic Design Agency USA 
                  </h2>
                </div>
                <p>
                At The Digital Creative  Design Agency USA, strong communication is the cornerstone of successful collaborations.
                </p>
                <ul className="list-wrap">
                  <li>
                    <div className="icon">
                      <img alt="about-area"  src="/img/icon/about_icon01.webp"  />
                    </div>
                    <div className="content">
                      <h4 className="title">Creativity without Boundaries</h4>
                      <p>
                      We inspire fresh ideas and bold approaches to tackle the challenges of tomorrow.
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <img alt="about-area"  src="/img/icon/about_icon02.webp"  />
                    </div>
                    <div className="content">
                      <h4 className="title">Collaboration at the Core</h4>
                      <p>
                      We provide you with graphic design services and collaborate with you as a design partner.
                      </p>
                    </div>
                  </li>
                </ul>

                <div className="about-content-bottom">
                  <span>Let’s Connect On A More Personal Level.</span>
                  <div className="read-more-btn">
                    <Link to="/about-us" className="btn">
                      Know Us More <span></span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutArea;
